module.exports = __webpack_public_path__ + "res/Roboto-Italic-webfont.woff?30183630b45058b7089f1111c2723026";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Italic-webfont.woff
// module id = 18
// module chunks = 0